<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content" style="max-height: 70vh; overflow-y: auto; padding: 10px">
  <form [formGroup]="formGroup">
    
    <mat-grid-list cols="1" rowHeight="75px">
  
      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>Application</mat-label>
          <input matInput type="text" [formControlName]="controls.ApplicationName" required>
        </mat-form-field>
      </mat-grid-tile>
      
      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>URL</mat-label>
          <input matInput type="text" [formControlName]="controls.ApplicationUrl" required>
        </mat-form-field>
      </mat-grid-tile>
      
      
      <mat-grid-tile>
        <mat-form-field class="w-90">
          <mat-label>Version</mat-label>
          <input matInput type="text" [formControlName]="controls.ApplicationVersion" required>
        </mat-form-field>
      </mat-grid-tile>
    
    
    </mat-grid-list>
  </form>
  <p style="color: red">{{errorMessage}}</p>
</div>

<mat-dialog-actions align="center">
  <button mat-raised-button [mat-dialog-close]="false" color="warn">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!formGroup.valid" (click)="onSaveRulesEngineMetadata()">
    Save
  </button>
</mat-dialog-actions>
